import { useWatch } from "react-hook-form";
import { useBreakpointValue } from "@chakra-ui/react";

import { SelectFormInput } from "components/inputs";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { useGetRequestContractShipTos } from "hooks/api/requestContract";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";
import { RequestContractFormProps } from "forms/RequestContractForm/RequestContractForm";
import { mobileOnly } from "util/styleHelpers";

const ShipToSelect = ({ id }: { id: string }) => {
  const selectedCustomerCode = useSelectedCustomerCode()[0];
  const { product } = useWatch<RequestContractFormProps>();
  const { data, isInitialLoading } = useGetRequestContractShipTos(
    selectedCustomerCode,
    product?.value
  );
  useSingleOptionAsFormDefault(id, data);
  const showLabel = useBreakpointValue(mobileOnly, { ssr: false });
  return (
    <SelectFormInput
      id={id}
      options={data}
      isLoading={isInitialLoading}
      isDisabled={!product?.value}
      label={showLabel ? "Ship To" : undefined}
    />
  );
};

export default ShipToSelect;
